<template>
  <div class="top_bg" style="min-height:100vh;-y: scroll;background-color: #FEB1DD;">
    <div class="week_bg" style="background-image: url('img/seventhMoon/top_bg.png');background-size: 100% 100%;background-repeat: no-repeat;">
        <div class="week_back" style="background-image: url('img/seventhMoon/w_back.png');" @click="goBack"></div>
    </div>
    <div class="house" style="background-image: url('img/seventhMoon/house.png');"></div>
    <div class="week_rule" style="background-image: url('img/seventhMoon/week_rule_.png');">
      <div class="rule_title" style="background-image: url('img/seventhMoon/rule_title.png');"></div>
      <div class="rule_gift" style="background-image: url('img/seventhMoon/rule_gift_bg.png');">
        <img class="week_gift_item" :src="week_gift.gift_url" alt="">
      </div>
      <div class="week_gift_name">{{week_gift.gift_name}}</div>
      <div class="rule_1" style="background-image: url('img/seventhMoon/rule_01.png');"></div>
      <div class="rule_2" style="background-image: url('img/seventhMoon/rule_02.png');"></div>
    </div>
      <div class="week_rule_3" style="background-image: url('img/seventhMoon/week_rule_3_.png');"></div>
    <div class="week_rule_2" style="background-image: url('img/seventhMoon/week_rule_2_.png');"></div>
   
      <div class="bottom_tip">本活动最终解释权归本平台所有</div>
    
  </div>
</template>

<script>
import "@/assets/css/base.css"
import "@/assets/css/seventh.css"

export default {
  name: 'weekStarRule',
  data () {
    return {
        week_gift:{}
    }
  },
  created() {
    this.week_gift = JSON.parse(this.$route.query.data)
  },
  methods: {
    goBack(){
        this.$router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
